import { render, staticRenderFns } from "./warehouseApplic.vue?vue&type=template&id=fb0c2288&scoped=true&"
import script from "./warehouseApplic.vue?vue&type=script&lang=js&"
export * from "./warehouseApplic.vue?vue&type=script&lang=js&"
import style0 from "./warehouseApplic.vue?vue&type=style&index=0&id=fb0c2288&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0c2288",
  null
  
)

export default component.exports